import * as React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from 'components/Dialog'
import { Form, TextInputContainer } from 'components/inputs'
import { useBrandingSettings } from 'hooks/branding'
import RenameJobViewModel from './RenameJobViewModel'

interface Props {
  vm: RenameJobViewModel
}

export default observer(function RenameJobDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <Dialog showing={vm.showing} onClose={!vm.rename.pending && vm.close}>
      <Form onSubmit={() => vm.rename()}>
        <DialogHeader>
          {!corporateMode && (
            <DialogIllustration
              src={require('assets/images/img_renamejob.svg')}
              alt="Woman writing on a sign"
            />
          )}
          <DialogTitle>Rename Job</DialogTitle>
          <DialogDescription>Edit the job name</DialogDescription>
        </DialogHeader>
        <DialogContent>
          <TextInputContainer
            autoFocus
            label="Name"
            data-test="rename-job-modal-new-name-input"
            help="This will be visible to everyone"
            placeholder={vm.job.legendName}
            model={vm}
            disabled={vm.rename.pending}
            field="newName"
          />
        </DialogContent>
        <DialogFooter bordered>
          <DialogButtonGroup>
            <DialogButton
              disabled={vm.rename.pending}
              onClick={vm.close}
              type="default"
            >
              Close
            </DialogButton>
            <DialogButton
              submit
              loading={vm.rename.pending}
              disabled={vm.rename.pending || !vm.nameHasChanged}
              type="primary"
              dataTest="rename-job-modal-confirm"
            >
              Save
            </DialogButton>
          </DialogButtonGroup>
        </DialogFooter>
      </Form>
    </Dialog>
  )
})
